"use strict";
/*
 * Created on 1. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../DomainObject");
/**
 * @author Radek Beran
 */


var Pagination =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Pagination, _DomainObject_1$Domai);

  /**
   * @param limit number of records to return
   * @param offset starting index (skip number of items)
   * @param totalCount total count of records available for given filter, filled within the result from the server
   */
  function Pagination(limit, offset, totalCount) {
    var _this;

    _classCallCheck(this, Pagination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Pagination).call(this));
    _this.limit = limit;
    _this.offset = offset;
    _this.totalCount = totalCount;
    return _this;
  }

  _createClass(Pagination, [{
    key: "withLimit",

    /**
     * @param limit number of records to return
     * @returns pagination with limit
     */
    value: function withLimit(limit) {
      return this.copy('limit', limit);
    }
    /**
     * @param offset starting index (skip number of items)
     * @returns pagination with offset
     */

  }, {
    key: "withOffset",
    value: function withOffset(offset) {
      return this.copy('offset', offset);
    }
  }, {
    key: "withTotalCount",
    value: function withTotalCount(totalCount) {
      return this.copy('totalCount', totalCount);
    }
    /**
     * Returns offset for the next page.
     */

  }, {
    key: "getNextOffset",
    value: function getNextOffset() {
      return this.offset + this.limit;
    }
    /**
     * Returns offset for the previous page.
     */

  }, {
    key: "getPreviousOffset",
    value: function getPreviousOffset() {
      var prevOffset = this.offset - this.limit;

      if (prevOffset < 0) {
        prevOffset = 0;
      }

      return prevOffset;
    }
    /**
     * Returns true if this pagination represents first page.
     */

  }, {
    key: "isFirstPage",
    value: function isFirstPage() {
      return this.offset <= 0;
    }
    /**
     * Returns true if this pagination represents last page, or false if there are next pages available.
     */

  }, {
    key: "isLastPage",
    value: function isLastPage() {
      var next = false;

      if (this.totalCount != null) {
        next = this.getNextOffset() < this.totalCount;
      }

      return !next;
    }
    /**
     * Number of current page (from 1).
     */

  }, {
    key: "getPage",
    value: function getPage() {
      return Math.floor(this.offset / this.limit) + 1;
    }
    /**
     * Total count of pages.
     */

  }, {
    key: "getPageCount",
    value: function getPageCount() {
      var cnt = null;

      if (this.totalCount != null) {
        var tc = this.totalCount;
        cnt = Math.floor(tc / this.limit) + (tc % this.limit > 0 ? 1 : 0);
      }

      return cnt;
    }
  }], [{
    key: "fromLimit",
    value: function fromLimit(limit) {
      return new Pagination(limit, 0, null);
    }
  }, {
    key: "fromLimitAndOffset",
    value: function fromLimitAndOffset(limit, offset) {
      return new Pagination(limit, offset, null);
    }
  }]);

  return Pagination;
}(DomainObject_1.DomainObject);

exports.Pagination = Pagination;